import type { UseHttp } from '~/api/interface'

export const fetchSpecialTopicByResourceId: UseHttp = (params, option) => {
  return useHttp.post('/api/specialTopicApi/resourceId', params, { ...option })
}
